import { Combobox, EInputTypes, InputNumber, InputTextCustom, TreeMenu } from 'medere-ui-framework'
import { useEffect, useRef, useState } from 'react'
import { Button } from 'primereact/button'
import { PrimeIcons } from 'primereact/api'
import { Modal } from 'medere-ui-framework'
import { Checkbox } from 'primereact/checkbox';
import './Accounting.css'
import { castAccountingsToItems, getAllCompanies } from '../../servicesHooks/Accounting/useAccountingService'
import { Toast } from 'primereact/toast'
import { showMessage } from '../../utils/messages'
import { axiosInstance } from '../../App'

function Accounting() {

    const [accountingAccounts, setAccountingAccounts]: any = useState([])
    const toast = useRef(null)
    const [selectedItemKey, setSelectedItemKey] = useState(null)
    const [description, setDescription] = useState('')
    const [alias, setAlias] = useState('')
    const [id, setId] = useState<number|null>(1)
    const [selectedItemValue, setSelectedItemValue] = useState<any>()
    const [selectedAccounting, setSelectedAccounting] = useState<any>(null)
    const [treeSize, setTreeSize] = useState<number>(0)
    // ERROR CONSTANTS
    const [errorID, setErrorID] = useState<boolean>(false)
    const [errorAlias, setErrorAlias] = useState<boolean>(false)
    const [errorDescription, setErrorDescription] = useState<boolean>(false)
    // MODAL CONSTANTS
    const [createAccountingModal, setCreateAccountingModal] = useState<boolean>(false)
    const [modal, setModal] = useState<boolean>(false)
    const [editModal, setEditModal] = useState<boolean>(false)

    useEffect(() => {
        if (selectedAccounting?.accounting) {
            getAllAccountingAccounts()
        }
    }, [selectedAccounting])

    function getAllAccountingAccounts() {
        if (selectedAccounting) {
            axiosInstance.get(`/api/secured/accounting/findAllAccountingAccountsById`, {
                params: {
                    pageSize: 0,
                    offset: 0,
                    accountingId: selectedAccounting?.accounting,
                }
            }).then((response) => {
                let _parentsAccount = []
                let _myParentAccount = null
                _parentsAccount = response.data.filter((element: any) => {
                    return element.parentaccountingaccountpk == null
                })
                let treeMenu = castAccountingsToItems(response.data, _parentsAccount, _myParentAccount)
                setAccountingAccounts(treeMenu)
            })
        }
    }


    function handleModalItem() {
        let allowsMovement = false
        if (selectedItemValue?.level == 4) {
            allowsMovement = true
        }
        if (id == null) {
            showMessage(toast, `El identificador no puede ser nulo`, 'error')
            return
        }
        let data = {
            accounting: selectedAccounting.accounting,
            description: description,
            alias: alias,
            allowsmovements: allowsMovement,
            parentaccountingaccountpk: selectedItemKey,
            identifier: selectedItemValue ? `${selectedItemValue.identifier}.${id}` : id,
            level: selectedItemValue ? selectedItemValue.level + 1 : 1,
        }
        let _errorID = handleErrorIdentifier()
        let _errorAlias = handleErrorDuplicateAlias(accountingAccounts)
        if (!(_errorID == null)) {
            setErrorID(_errorID)
        }
        if (!(_errorAlias == null)) {
            setErrorAlias(_errorAlias)
        }
        if (!_errorID && !_errorAlias) {
            axiosInstance.post(`/api/secured/accounting/accountingAccount`, data).then(() => {
                setModal(false)
                getAllAccountingAccounts()
                setId(null)
                setDescription('')
                setAlias('')
            }).catch((error) => {
                showMessage(toast, `Error al agregar cuenta contable`, 'error')
                console.error(error)
            })
        }

    }

    function handleEditModalItem() {
        let allowsMovement = false
        if (selectedItemValue?.level == 4) {
            allowsMovement = true
        }
        let data = {
            accountingaccount: selectedItemKey,
            description: description,
            alias: alias,
            allowsmovements: allowsMovement,
        }
        let _errorAlias = false
        let _errorDescription = false
        if (!alias == null && alias.localeCompare(selectedItemValue.alias, 'es-ES', { sensitivity: 'base' }) != 0) {
            _errorAlias = handleErrorDuplicateAlias(accountingAccounts)

        }
        if (!description == null && description.localeCompare(selectedItemValue.description, 'es-ES', { sensitivity: 'base' }) != 0) {
            _errorDescription = handleErrorDuplicateDescription(accountingAccounts)
        }
        if (!(_errorAlias == null)) {
            setErrorAlias(_errorAlias)
        }
        if (!(_errorDescription == null)) {
            setErrorDescription(_errorDescription)
        }
        if (!_errorAlias && !_errorDescription) {
            axiosInstance.post(`/api/secured/accounting/editAccountingAccount`, data).then(() => {
                setEditModal(false)
                getAllAccountingAccounts()
                cleanVariables()
            })
        }

    }


    function findHandleAccountingAccount(accountingAccount: []) {
        let _account: any = accountingAccount.find((acc: any) => {
            return acc.key === selectedItemKey
        })
        if (_account) {
            return _account
        } else {
            accountingAccount.forEach((element: any) => {
                if (element.children && !_account) {
                    _account = findHandleAccountingAccount(element.children)
                }
            })
            return _account
        }

    }

    function handlePlusButton() {
        let _selectedItem = findHandleAccountingAccount(accountingAccounts)
        if (_selectedItem?.level >= 5) {
            showMessage(toast, `No se puede agregar una cuenta contable en el nivel ${selectedAccounting.treesize + 1}`, 'error')
            return
        }
        if (_selectedItem) {
            setSelectedItemValue(_selectedItem)
        }
        setModal(true)
    }

    function handleErrorIdentifier() {
        let _error = false
        if (selectedItemValue && id) {
            if (selectedItemValue.children) {
                selectedItemValue.children.forEach((element: any) => {
                    if (element.identifier.localeCompare(`${selectedItemValue.identifier}.${id}`) == 0) {
                        _error = true
                        return
                    }
                })
            }
        } else if (id) {
            accountingAccounts.forEach((element: any) => {
                if (element.identifier.localeCompare(`${id}`) == 0) {
                    _error = true
                    return
                }
            })
        }
        return _error
    }


    function handleErrorDuplicateAlias(_parentsAccount: []) {
        let _error = false
        if (selectedItemValue && alias) {
            _parentsAccount.forEach((parent: any) => {
                if (parent.alias) {
                    if (parent.alias.localeCompare(alias, 'es-ES', { sensitivity: 'base' }) == 0) {
                        _error = true
                        return
                    }
                }
                if (parent.children && parent.children.length > 0) {
                    _error = handleErrorDuplicateAlias(parent.children)
                }

            })
        }
        return _error
    }

    function handleErrorDuplicateDescription(_parentsAccount: []) {
        let _error = false
        if (selectedItemValue && description) {
            _parentsAccount.forEach((parent: any) => {
                if (parent.description) {
                    if (parent.description.localeCompare(description, 'es-ES', { sensitivity: 'base' }) == 0) {
                        _error = true
                        return
                    }
                }
                if (parent.children && parent.children.length > 0) {
                    _error = handleErrorDuplicateDescription(parent.children)
                }

            })
        }
        return _error
    }


    function handleEditButton() {
        let _selectedItem = findHandleAccountingAccount(accountingAccounts)
        if (_selectedItem) {
            setId(_selectedItem.identifier)
            setDescription(_selectedItem.description)
            setAlias(_selectedItem.alias)
            setSelectedItemValue(_selectedItem)
        }
        setEditModal(true)
    }

    function handleCreateAccountingModal() {
        let data = {
            description: description,
            company: selectedAccounting.company,
            treesize: treeSize,
        }
        axiosInstance.post(`/api/secured/accounting/createAccounting`, data).then((resp) => {
            setCreateAccountingModal(false)
            cleanVariables()
            setAccountingAccounts([])
            setSelectedAccounting({ ...selectedAccounting, accounting: resp.data.accounting })
        })
    }

    function cleanVariables() {
        setId(null)
        setDescription('')
        setAlias('')
        setSelectedItemKey(null)
        setSelectedItemValue(null)
        setErrorAlias(false)
        setErrorID(false)
    }


    return (
        <div className='m-4 viewContainer'>
            <div className='flex align-items-center justify-content-between flex-column md:flex-row'>
                <h2 className='textHeading text-base md:text-2xl'>PLAN DE CUENTAS</h2>
                <div className='flex justify-content-end align-items-center'>
                    <Button type='button' disabled={!selectedItemKey} className='buttonMain' icon={PrimeIcons.PENCIL} onClick={handleEditButton}></Button>
                    <Button type='button' disabled={!selectedAccounting?.accounting} className='buttonMain' icon={PrimeIcons.PLUS} onClick={handlePlusButton}></Button>
                </div>
            </div>

            <Modal visible={modal} setVisible={setModal} header='Agregar cuenta contable' footerButtonRightText='Aceptar' onClickRightBtn={handleModalItem} onHideCustom={cleanVariables}>
                <div>
                    {selectedItemValue && selectedItemValue.caption && (
                        <p className='text'>{selectedItemValue.caption.toUpperCase()} {'>'} </p>
                    )}
                    <InputTextCustom inputType={EInputTypes.NUMBER} value={id} onChange={(e) => {
                        if (e.target.value == 0) {
                            setId(1)
                            return
                        }
                        setId(e.target.value)
                        setErrorID(false)
                    }} label="Identificador" error={errorID} min={1} caption={errorID?'El identificador ingresado ya existe':''} />
                    <InputTextCustom value={description} onChange={(e: any) => {
                        setDescription(e.target.value)
                    }} label="Descripción" error={errorDescription} caption={errorDescription ? 'La descripción ingresada ya existe' : ''} />
                    <InputTextCustom value={alias} onChange={(e: any) => {
                        setAlias(e.target.value)
                        setErrorAlias(false)
                    }} label="Alias" error={errorAlias} caption={errorAlias ? 'El alias ingresado ya existe' : ''} />
                    {
                        selectedItemValue?.level == 4 &&
                        <div className='flex align-items-center'>
                            <Checkbox inputId='allowsMovement' disabled checked />
                            <label htmlFor='allowsMovement' className='ml-2'>Permitir movimientos</label>
                        </div>
                    }

                    {selectedItemValue && selectedItemValue.caption && (
                        <p className='text mt-2'> Usted esta agregando a {selectedItemValue.caption.toUpperCase()} </p>
                    )}

                </div>
            </Modal>

            <Modal visible={editModal} setVisible={setEditModal} header='Editar cuenta contable' footerButtonRightText='Aceptar' onClickRightBtn={handleEditModalItem} onHideCustom={cleanVariables} >
                <div>
                    {selectedItemValue && selectedItemValue.caption && (
                        <p className='text'>{selectedItemValue.caption} {'>'} </p>
                    )}
                    <p className='text'>Identificador ({id})</p>
                    <InputTextCustom value={description} onChange={(e: any) => {
                        setDescription(e.target.value)
                    }} label="Descripción" error={errorDescription} caption={errorDescription ? 'La descripción ingresada ya existe' : ''} />
                    <InputTextCustom value={alias} onChange={(e: any) => {
                        setAlias(e.target.value)
                        setErrorAlias(false)
                    }} label="Alias" error={errorAlias} caption={errorAlias ? 'El alias ingresado ya existe' : ''} />
                    {
                        selectedItemValue?.level == 4 &&
                        <div className='flex align-items-center'>
                            <Checkbox inputId='allowsMovement' disabled checked={true} />
                            <label htmlFor='allowsMovement' className='ml-10'>Permitir movimientos</label>
                        </div>
                    }

                    {selectedItemValue && selectedItemValue.caption && (
                        <p className='text'> Usted está editando {selectedItemValue.caption} </p>
                    )}
                </div>
            </Modal>

            <Modal visible={createAccountingModal} setVisible={setCreateAccountingModal} header='Agregar plan de cuentas'
                footerButtonRightText='Aceptar' onClickRightBtn={handleCreateAccountingModal} onHideCustom={cleanVariables}>
                <InputTextCustom value={description} onChange={(e: any) => {
                    setDescription(e.target.value)
                }} label="Descripción" error={errorDescription} />
                <InputNumber value={treeSize} onChange={(e: any) => {
                    setTreeSize(e.target.value)
                }} label='Profundidad del arbol'></InputNumber>
            </Modal>

            <div className='flex flex-column'>
                <Combobox getItems={getAllCompanies} label='Seleccione una compañia' className='w-full md:w-1/4' optionLabel='description' value={selectedAccounting} setValue={(comp: any) => {
                    setSelectedAccounting(comp)
                    // if(no tiene accounting deberia mostrar un modal para crear uno)
                    if (comp && !comp?.accounting) setCreateAccountingModal(true)
                }} />
                <div className="w-full md:w-3/6 p-tree">
                    <TreeMenu
                        items={accountingAccounts}
                        selectedItemKey={selectedItemKey}
                        notCloseOnToggle
                        onSelectionChange={(e: any) => {
                            if (e.value == selectedItemKey) {
                                setSelectedItemKey(null)
                            } else {
                                setSelectedItemKey(e.value)
                            }

                        }}
                        onNodeClick={() => { }}
                    />
                </div>
            </div>
            <Toast ref={toast} position="bottom-right" />
        </div>
    )
}

export default Accounting
